import React from 'react';
import PropTypes from 'prop-types';
import ScrollArea from 'components/scroll-area/scroll-area';
/* styles */
import './account.scss';

class Account extends React.PureComponent {
    render() {
        const buttonClassName = !this.props.isExternalAccount ? 'col-12' : 'col-24';

        const lastUpdateTitle = `Last update: ${process.env.LAST_UPDATE_DATE} | ${process.env.LAST_UPDATE_MESSAGE}`;

        return (
            <div className="sten-left-sidebar-panel sten-account">
                <div className="sten-content__header text-uppercase">
                    <div className="flex-grow">
                        <h1>My account</h1>
                    </div>
                </div>
                <div className="sten-content__body sten-account__body">
                    <ScrollArea className="sten-account__body-content">
                        <div className="sten-content__section text-center">
                            <h2 className="sten-account__name">{this.props.name}</h2>
                        </div>
                        <div className="sten-content__section text-center">
                            <h6 className="text-secondary" title={lastUpdateTitle}>
                                App version: {process.env.APP_VERSION}
                            </h6>
                        </div>
                    </ScrollArea>
                    <footer className="sten-content__footer flex-row">
                        {!this.props.isExternalAccount && (
                            <div className={buttonClassName}>
                                <a
                                    className="btn btn--secondary col-24 sten-account__body-btn"
                                    href={`/Account/ChangePassword?ReturnUrl=${this.props.pathName}`}
                                >
                                    Change password
                                </a>
                            </div>
                        )}
                        <div className={buttonClassName}>
                            <a
                                className="btn btn--primary col-24"
                                href="/Account/Logout"
                            >
                                Logout
                            </a>
                        </div>
                    </footer>
                </div>
            </div>
        );
    }
}

Account.propTypes = {
    isExternalAccount: PropTypes.bool.isRequired,
    name: PropTypes.string,
    pathName: PropTypes.string
};

Account.defaultProps = {
    name: '',
    pathName: ''
};

export default Account;
